import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../../components/common/Button';
import DataTypes from '../../components/Table/dataTypes';
import { ppiCreateRoute } from '../../routes';

const formatFormulaCode = formulaCode => {
  return `${formulaCode.substring(0, 3)} ${formulaCode.substring(
    3,
    7
  )} ${formulaCode.substring(7, formulaCode.length)}`;
};

export default {
  PresentationName: {
    name: 'presentationName',
    // dataField: 'presentationName',
    calculateCellValue: (data, { language }) => {
      const presentaionName = data.presentationName;
      return presentaionName[language];
    },
    label: 'Product Name',
    width: 500
  },
  PresentationNameExc: {
    name: 'presentationName',
    // dataField: 'presentationName',
    calculateCellValue: (data, { language }) => {
      const presentaionName = data.presentationName;
      return presentaionName[language];
    },
    label: 'Product Name',
    width: 550
  },
  IFoodIDExc: {
    name: 'iFoodID',
    label: 'iFood ID',
    // dataField: 'itemCode',
    calculateCellValue: data => formatFormulaCode(data.itemCode),
    width: 150,
    grow: 0,
    shrink: 0
  },
  ModifyDateExc: {
    name: 'modifyDate',
    dataField: 'modifyDate',
    dataType: DataTypes.Date,
    label: 'iFood Modify Date',
    searchable: false,
    width: 280,
    grow: 0
  },
  Formula: {
    name: 'itemCode',
    label: 'Item Code',
    dataField: 'itemCode',
    width: 100,
    grow: 0,
    shrink: 0
  },
  IFoodID: {
    name: 'iFoodID',
    label: 'iFood ID',
    // dataField: 'itemCode',
    calculateCellValue: data => formatFormulaCode(data.itemCode),
    width: 200,
    grow: 0,
    shrink: 0
  },
  ModifyDate: {
    name: 'modifyDate',
    dataField: 'modifyDate',
    dataType: DataTypes.Date,
    label: 'iFood Modify Date',
    searchable: false
  },
  CreatePpi: {
    name: 'createPpi',
    sortable: false,
    label: '',
    width: 175,
    grow: 0,
    shrink: 0,
    CellValue: ({ rowData }) => (
      <Button route={ppiCreateRoute(rowData.data.itemCode)}>
        <FormattedMessage id="ppi.createInstruction" />
      </Button>
    )
  }
};
